import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilitiesService } from 'src/app/core/service/utilities.service';

@Component({
  selector: 'app-form-decision',
  templateUrl: './form-decision.component.html',
  styleUrls: ['./form-decision.component.scss']
})
export class FormDecisionComponent implements OnInit {

  indiceTab: number = 0;
  decisionForm: FormGroup;
  itemToSave:any={}
  @Output() onSubmitDecision = new EventEmitter<any>();

  constructor(    private utilities: UtilitiesService,
  ) {
    
  }

  isInvalid(controlName: string): boolean {
    const control = this.decisionForm.get(controlName);
    return control?.invalid && control?.touched;
  }

  onSubmit() {
    if (!this.itemToSave || !this.itemToSave.statut) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner décision",
        "bottom",
        "center"
      );
      return
    }
    if (this.itemToSave.statut =="reject" && !this.itemToSave.commentaire) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner raison",
        "bottom",
        "center"
      );
      return
    }
    this.onSubmitDecision.emit(this.itemToSave);
  }
  selectedChangeValue(event : any)
  {
    console.log("le event selectedChangeValue",event);
    
    if(!event) this.indiceTab = 0;

    this.indiceTab = event;
  } 

  ngOnInit(): void {
  }

}
